<template>
  <div class="event-card" @click="openEventDetails">
    <img
      v-if="event.cover_image || event.cover || event.poi?.cover"
      :src="imageUrl(event.cover_image || event.cover || event.poi.cover)"
      class="event-image"
      alt=""
    />

    <div class="event-content">
      <h3 class="event-title">
        {{ event.name || event.title }}
      </h3>

      <div class="event-date">
        {{ formatDate(event.date_from) }}
        -
        {{ formatDate(event.date_to) }}

        <template v-if="event.opening_hour">
          {{ event.opening_hour }}
        </template>

        <template v-if="event.closing_hour"> - {{ event.closing_hour }} </template>
      </div>

      <div class="event-location">
        <img src="@/assets/icons/marker.png" alt="location" class="location-icon" />
        {{ event.poi_name || event.poi?.name }}
      </div>

      <div class="event-description-wrapper">
        <img src="@/assets/icons/info.png" alt="Info" class="info-icon" />

        <div class="event-description">
          <button class="see-more-btn" @click="openEventDetails">
            {{ $t("events.seeMore") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import M2wApi from "@/services/m2w_api";

export default {
  name: "EventsCard",

  props: {
    event: {
      type: Object,
      required: true,
    },
  },

  methods: {
    openEventDetails() {
      const poiForMap = {
        ...this.event.poi,
        parent: {
          id: this.event.parent_id,
        },
      };

      // this.$emit("select-event-poi", poiForMap);

      this.$router
        .push({
          name: "eventDetails",
          params: {
            id: String(this.event.id),
          },
          query: {
            poi_id: String(this.event.poi_id),
            parent: String(this.event.parent_id),
          },
        })
        .catch((error) => {
          if (error?.name !== "NavigationDuplicated") {
            console.error("Eroare la deschiderea evenimentului:", error);
          }
        });
      this.$emit("select-event-poi", poiForMap);
    },
    imageUrl(path) {
      if (!path) return "";
      if (path.startsWith("http")) return path;
      return M2wApi.host_address + path;
    },

    formatDate(date) {
      if (!date) return "";

      return new Date(date).toLocaleDateString(this.$i18n.locale, {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },
  },
};
</script>

<style scoped>
.event-card {
  display: flex;
  margin-top: 5px;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  border: 0;
  overflow: hidden;
  min-height: 120px;
  cursor: pointer;
}

.event-image {
  width: 125px;
  min-width: 125px;
  height: 120px;
  object-fit: cover;
}

.event-content {
  font-family: Quicksand;
  padding: 10px 12px;
  flex: 1;
}

.event-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 5px;
}

.event-date {
  display: inline-block;
  font-display: Quicksand;
  background: #d0d0d0;
  color: #464646;
  padding: 5px 9px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
}

.event-location {
  font-family: Quicksand;
  line-height: 1.3em;
  line-height: 1.25;
  display: flex;
  align-items: center;
  gap: 6px;
  /* margin-top: 5px; */
  font-size: 12px;
  color: #777;
  font-weight: 600;
  margin-bottom: 5px;
}

.event-description {
  font-family: Quicksand;
  color: #777;
  font-size: 13px;
  line-height: 1.25;
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  /* padding-top: 2px; */
}
.location-icon {
  width: 16px;
  height: 18px;
  /* object-fit: contain; */
}

.event-description-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding-right: -1px;
}

.info-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  /* margin-top: 2px;  */
}

.see-more-btn {
  font-family: Quicksand;
  color: #333;
  font-size: 13px;
  line-height: 1.25;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  /* padding-top: 4px; */
  line-height: 1.3em;
}
</style>